module.exports = __webpack_public_path__ + "img/INF-i-1-II.c5edf082.png";